import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import QueryString from 'query-string';
import styled from 'styled-components';
import classNames from 'classnames/bind';
import { Formik } from 'formik';
import styles from './Login.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from '~/history.js';
import { login } from '~/store/modules/session';
import constants from '~/constants.js';
import Form from './Form';
import { Logo } from '../common';

const cx = classNames.bind(styles);

const Footer = styled.footer`
  margin-top: 1rem;
  text-align: center;

  a:not(:first-child) {
    margin-left: 0.5rem;
  }
`;

const Button = styled.button`
  margin-top: 1rem;
  font-size: 0.875rem;
  width: 256px;
  padding: 0.5rem 1rem;
  border: 1px solid transparent;
  border-radius: 3px;
  border-color: ${constants.colors.mercury};
  color: ${constants.colors.primaryLight};
  background-color: ${constants.colors.white};
  line-height: 1.618;
  text-align: center;
  transition: background 0.15s ease;
  cursor: pointer;
`;

class LoginContainer extends Component {
  componentDidMount() {
    const { isLoggedIn } = this.props;

    if (isLoggedIn) {
      history.push('/');
      return;
    }
  }

  validateForm = (values, props) => {
    const errors = {};
    if (!values.login) {
      errors.login = '필수로 입력해야하는 값입니다.';
    }
    if (!values.password) {
      errors.password = '필수로 입력해야하는 값입니다.';
    } else if (values.password.length < 4) {
      errors.password = '올바르지 않은 형식입니다.';
    }
    return errors;
  };

  handleFormSubmit = (values, { setSubmitting }) => {
    const redirect = QueryString.parse(this.props.location.search).redirect;

    this.props
      .login({
        login: values.login.trim(),
        password: values.password.trim(),
      })
      .then(() => {
        setSubmitting(false);
        history.push(redirect);
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          alert(
            '아이디/휴대전화번호나 비밀번호가 틀립니다.\n확인 후 정확하게 다시 입력해주세요.'
          );
        } else {
          alert('에러가 발생 하였습니다.\n잠시 후에 다시 시도해주세요.');
        }
        setSubmitting(false);
      });
  };

  render() {
    return (
      <div className={cx('login')}>
        <h1>
          <Logo />
        </h1>
        <h2>로그인</h2>
        <Formik
          initialValues={{
            login: '',
            password: '',
          }}
          validate={this.validateForm}
          onSubmit={this.handleFormSubmit}
          render={({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            isValid,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Form.Group
                id="login"
                label="아이디 또는 휴대전화번호"
                error={touched.login && errors.login}
              >
                <Form.MaskedInput
                  autoCapitalize="none"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.login}
                />
              </Form.Group>
              <Form.Group
                id="password"
                label="비밀번호"
                error={touched.password && errors.password}
              >
                <Form.Input
                  type="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                />
              </Form.Group>
              <Form.Submit disabled={!isValid || isSubmitting}>
                로그인
              </Form.Submit>
            </Form>
          )}
        />
        <Footer>
          <p>
            <Link to="https://app.cashnote.kr/account/retrieve" target="_blank">
              아이디 찾기
            </Link>
            <Link to="https://app.cashnote.kr/password/reset" target="_blank">
              비밀번호 재발급
            </Link>
          </p>
          <p>
            <Link to="https://app.cashnote.kr/signup" target="_blank">
              <Button>회원 가입</Button>
            </Link>
          </p>
        </Footer>
      </div>
    );
  }
}

export default connect(
  ({ session }) => ({
    isLoggedIn: session.isLoggedIn,
  }),
  dispatch => ({
    login: bindActionCreators(login, dispatch),
  })
)(LoginContainer);



// WEBPACK FOOTER //
// ./src/components/Login/LoginContainer.js